export const LEFT_LAYOUT_WIDTH = 550
export const RIGHT_LAYOUT_WIDTH = `calc(100vw - ${LEFT_LAYOUT_WIDTH}px)`
export const LAYOUT_HEIGHT = '100%'
